import Banner from "./Banner";
import Prezentacja from "./files/Prezentacja.pdf";
import { Link } from "react-router-dom";
import Prezentacja_Wlaczanie from "./files/Wlaczanie_i_roznorodnosc.pdf"
import Prezentacja_Dom from "./files/Budowa_domu.pdf"
import Prezentacja_Srodowisko from "./files/Walka_ze_zmiana_klimatu.pdf"
import Film_Dom from "./files/Budowa_domu.mp4"

let Links = () => {
    return(
        <div id = "textContainer">
            <h1>Linki</h1>
            <hr />
            <Banner />
            <hr /><br />

            <h2><strong>Upowszechnianie</strong></h2>
            <ul>
                <li><a href = "https://zsikielce-my.sharepoint.com/:v:/g/personal/orlinskia_zsi_kielce_pl/Edi5HummSy1Lmekp-2UrSfQB_7rpcyxjxio9ZjuXUwqAdA?e=E0EhaZ" target = "_blank">Film z wyjazdu do Sewilli</a></li>
                <li><a href = {Prezentacja} target = "_blank">Prezentacja z wyjazdu do Sewilli</a></li>
                <li><a href = "https://zsikielce-my.sharepoint.com/:u:/g/personal/orlinskia_zsi_kielce_pl/EZd56GFHHK5Egd0EFojS89oBpSjqZbSIMFgpHHqp3kWDfw?e=AqLED3" target = "_blank">Gra stworzona przez uczestników</a></li>
                <li><Link to="/upowszechnianie/galeria">Zdjęcia ze spotkania podsumowującego</Link></li>
                <li><a href = "https://zsikielce-my.sharepoint.com/:v:/g/personal/orlinskia_zsi_kielce_pl/EbGrY8vpQUBAuvhDaPoNRDQBw9rsCMvAtXW56S3Or9k0Ww?e=jc7Ugg" target = "_blank">OZE na stażu w Sewilli</a></li>
            </ul>

            <br />
            
            <h2><strong>Erasmus Days 2024</strong></h2>
            <ul>
                <li><a href = "https://youtu.be/cHGuexLKTUE" target="_blank">Film</a></li>
                <li><a href = {Prezentacja_Wlaczanie} target = "_blank">Włączanie i różnorodność w programie Erasmus+</a></li>
                <li><a href = {Prezentacja_Dom} target = "_blank">Jak zbudować dom energooszczędny</a></li>
                <li><a href = {Prezentacja_Srodowisko} target = "_blank">Środowisko i walka ze zmianą klimatu</a></li>
                <li><a href = "https://drive.google.com/file/d/17Vw3WYdzIITK1jafU_wxUpfVKGs_T2nV/view?usp=sharing" target = "_blank">Jingiel reklamowy 1</a></li>
                <li><a href = "https://drive.google.com/file/d/15x34BHPkRWKUNeRWhIB_n0jxUhG_PYCy/view?usp=sharing" target = "_blank">Jingiel reklamowy 2</a></li>
            </ul>
            
            <br />

            <h2><strong>O stażu w mediach</strong></h2>
            <ul>
                <li><a href = "https://kielce.naszemiasto.pl/erasmusday-w-zespole-szkol-informatycznych-w-kielcach/ar/c5-9817673?fbclid=IwZXh0bgNhZW0CMTEAAR0TvOPai3imbqqc2naZH_KBSTJsPzGCebrrIoKyceBu-9_HZfKS2gOKNm4_aem_btRmVHs-JEPRZFHthVBaNQ" target = "_blank">Erasmus Days w Zespole Szkół Informatycznych w Kielcach. Warsztaty, koncert i ciekawe doświadczenia z Hiszpanii.</a></li>
            </ul>

            <br />

            <h2><strong>Instytucja partnerska EuroMind</strong></h2>
            <ul>
                <li><a href = "https://www.euromind.es/" target = "_blank">Strona internetowa</a></li>
                <li><a href = "https://www.facebook.com/euromind.spain" target = "_blank">Facebook</a></li>
            </ul>

            <br />

            <h2><strong>O stażu w EuroMind</strong></h2>
            <ul>
                <li><a href = "https://www.facebook.com/euromind.spain/posts/pfbid0YpfW2df1TBU83RnLJKmGdniTamesjDtVnhHcUyvZUR1Ja2FMZJC2LntDAfX8qkmwl" target = "_blank">Facebook</a></li>
                <li><a href = "https://www.instagram.com/p/C6s_RXjiRnT/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" target = "_blank">Instagram</a></li>
            </ul>

            <br />

            <h2><strong>Filmy instruktażowe</strong></h2>
            <ul>
                <li><a href = "https://zsikielce-my.sharepoint.com/:v:/g/personal/orlinskia_zsi_kielce_pl/ESIpA3VwYKFMudaq9WsDixMBG693ENKfvODTupUvul6XTw?e=ZD11qc" target = "_blank">Jak przygotować komputer do tworzenia gier video</a></li>
                <li><a href = {Film_Dom} target = "_blank">Jak zbudować dom energooszczędny</a></li>
                
            </ul>

            <br />

        </div>
    )
}

export default Links;